import { MutationTree } from 'vuex';
import { LoaderState } from '@/store/loader/types';

export const mutations: MutationTree<LoaderState> = {
  setActive(state, value = false) {
    state.active = value;
  },
};
